import { denormalize } from "normalizr";
import { admin } from "../../../api/schema";

export default state => {
  try {
    const items = state.admins.ids;

    const denormalized = denormalize(
      { items },
      { items: [admin] },
      state.entities
    );
    return denormalized.items;
  } catch (err) {
    return [];
  }
};
